
import { Placement } from '@post-office/placements-frontend/statuspage-navigation-spotlight-placement';
export default Placement;
